




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
@Component({
  name: 'UploadImage'
})
export default class extends Vue {
  @Prop({ default: '.jpg,.jpeg,.png' }) type: string
  @Prop({ default: 2 }) size: number
  @Prop({ default: '' }) propImageUrl: string

  private headers = {
    token: getToken()
  }
  private imageUrl = ''
  handleRemove() {}

  @Watch('propImageUrl')
  private onChange(val) {
    this.imageUrl = val
  }

  handleError(err, file, fileList) {
    console.log(err, file, fileList, 'handleError')
    this.$message({
      message: '图片上传失败',
      type: 'error'
    })
  }

  handleAvatarSuccess(response: any, file: any, fileList: any) {
    console.log('Image upload response:', response)
    // 确保使用完整的URL路径
    if (response && response.code === 1 && response.data) {
      // 直接使用服务器返回的完整URL（包含签名参数）
      this.imageUrl = response.data
      console.log('图片上传成功，URL:', this.imageUrl)
      // 检查URL是否包含必要的参数
      if (this.imageUrl.includes('?')) {
        console.log('URL包含查询参数，这是带签名的OSS URL')
      } else {
        console.log('URL不包含查询参数，可能无法访问')
      }
      this.$emit('imageChange', this.imageUrl)
    } else {
      console.error('图片上传响应异常:', response)
      this.$message.error('图片上传失败')
    }
  }

  oploadImgDel() {
    this.imageUrl = ''
    this.$emit('imageChange', this.imageUrl)
  }
  beforeAvatarUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < this.size
    if (!isLt2M) {
      this.$message({
        message: `上传文件大小不能超过${this.size}M!`,
        type: 'error'
      })
      return false
    }
  }
}
